import { put, call, takeLatest } from "redux-saga/effects";

import {
  insertProductRequest,
  insertProductSuccess,
  insertProductFailure,
  getProductRequest,
  getProductSuccess,
  getProductFailure,
  getcategoryRequest,
  getcategorySuccess,
  getcategoryFailure,
  getcompaniesRequest,
  getcompaniesSuccess,
  getcompaniesFailure,
  editProductRequest,
  editProductSuccess,
  editProductFailure,
  createBrandRequest,
  createBrandSuccess,
  createBrandFailure,
  updateBrandRequest,
  updateBrandSuccess,
  updateBrandFailure,
  getBrandRequest,
  getBrandSuccess,
  getBrandFailure,
  deleteProductRequest,
  deleteProductSuccess,
  deleteProductFailure,
  deleteBrandRequest,
  deleteBrandSuccess,
  deleteBrandFailure,
} from "./Product-slice";
import { API_URL } from "../../utils/Api";
import axiosInstance from "../../utils/AxiosConfig";
import { getBuyerToken } from "../../utils/authStorage";

function* insertproductSaga(action) {
  try {
    const response = yield axiosInstance.get(`createProduct`, {
      params: action.payload,
    });
    yield put(insertProductSuccess(response.data));
  } catch (error) {
    yield put(insertProductFailure(error.message));
  }
}

export function* watchinsertproduct() {
  yield takeLatest(insertProductRequest.type, insertproductSaga);
}

function* getproductSaga(action) {
  const token = getBuyerToken();
  let url = "";
  if (token) {
    url = "getProducts";
  } else {
    url = "getProducts/public";
  }
  try {
    const response = yield axiosInstance.get(url, {
      params: action.payload,
    });
    yield put(getProductSuccess(response.data));
  } catch (error) {
    yield put(getProductFailure(error.message));
  }
}

export function* watchgetproduct() {
  yield takeLatest(getProductRequest.type, getproductSaga);
}

function* getcategorySaga(action) {
  const token = getBuyerToken();
  let url = "";
  if (token) {
    url = "getCategories";
  } else {
    url = "getCategories/public";
  }
  try {
    const response = yield axiosInstance.get(url, {
      params: action.payload,
    });
    yield put(getcategorySuccess(response.data));
  } catch (error) {
    yield put(getcategoryFailure(error.message));
  }
}

export function* watchgetcategory() {
  yield takeLatest(getcategoryRequest.type, getcategorySaga);
}

function* getcompaniesSaga(action) {
  try {
    const response = yield axiosInstance.get(`getCompanies`, {
      params: action.payload,
    });
    yield put(getcompaniesSuccess(response.data));
  } catch (error) {
    yield put(getcompaniesFailure(error.message));
  }
}

export function* watchgetcompanies() {
  yield takeLatest(getcompaniesRequest.type, getcompaniesSaga);
}

function* editproductSaga(action) {
  try {
    const response = yield axiosInstance.get(`updateProduct`, action.payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    yield put(editProductSuccess(response.data));
  } catch (error) {
    yield put(editProductFailure(error.message));
  }
}

export function* watcheditproduct() {
  yield takeLatest(editProductRequest.type, editproductSaga);
}

function* createBrandSaga(action) {
  try {
    const response = yield axiosInstance.post(`createBrand`, action.payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    yield put(createBrandSuccess(response.data));
  } catch (error) {
    yield put(createBrandFailure(error.message));
  }
}

export function* watchcreateBrand() {
  yield takeLatest(createBrandRequest.type, createBrandSaga);
}

function* updateBrandSaga(action) {
  try {
    const response = yield axiosInstance.post(`updateBrand`, action.payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    yield put(updateBrandSuccess(response.data));
  } catch (error) {
    yield put(updateBrandFailure(error.message));
  }
}

export function* watchupdateBrand() {
  yield takeLatest(updateBrandRequest.type, updateBrandSaga);
}

function* getBrandSaga(action) {
  const token = getBuyerToken();
  let url = "";
  if (token) {
    url = "getAllBrands";
  } else {
    url = "getAllBrands/public";
  }
  try {
    const response = yield axiosInstance.get(url, {
      params: action.payload,
    });
    yield put(getBrandSuccess(response.data));
  } catch (error) {
    yield put(getBrandFailure(error.message));
  }
}

export function* watchgetBrand() {
  yield takeLatest(getBrandRequest.type, getBrandSaga);
}

function* deleteProductSaga(action) {
  // console.log('action.payload',action.payload)
  try {
    const response = yield axiosInstance.delete(
      `deleteProduct/${action.payload}`
    );
    yield put(deleteProductSuccess(response.data));
  } catch (error) {
    yield put(deleteProductFailure(error.message));
  }
}

export function* watchdeleteProduct() {
  yield takeLatest(deleteProductRequest.type, deleteProductSaga);
}

function* deleteBrandSaga(action) {
  try {
    const response = yield axiosInstance.delete(
      `deleteBrand/${action.payload}`
    );
    yield put(deleteBrandSuccess(response.data));
  } catch (error) {
    yield put(deleteBrandFailure(error.message));
  }
}

export function* watchdeleteBrand() {
  yield takeLatest(deleteBrandRequest.type, deleteBrandSaga);
}
